import React, { ReactNode, FC, PropsWithChildren } from 'react';

import { ABTest, Redirect } from '@lucid/components-react';
import { getUsernameCookie, isBrowser } from '@lucid/utils';

interface ABTestRedirectLoggedInToDocsListProps {
  children: ReactNode;
  pageType: string;
}

const ABTestRedirectLoggedInToDocsList: FC<PropsWithChildren<ABTestRedirectLoggedInToDocsListProps>> = ({
  children,
  pageType = '',
}) => {
  const usernameCookie = getUsernameCookie();
  const pathname = isBrowser() ? window.location.pathname : '';
  const isCorrectPage = pageType === 'twentyone-homepage' && !pathname.includes('/landing');
  const shouldRedirect = !!usernameCookie && isCorrectPage;

  return (
    <ABTest
      isAboveTheFold
      branchesToRender={['T_A', 'T_B']}
      defaultBranch="T_B"
      ssrBranch="T_B"
      testName="Y23Q1_RedirectLoggedInToDocsList"
    >
      <ABTest.Context.Consumer>
        {({ branch }) => (
          <>
            <ABTest.Branch branch="T_A">
              {branch === 'T_A' && shouldRedirect ? (
                <Redirect passQueryParams siteDomain="lucidchart.com" to="https://lucid.app/documents" />
              ) : (
                children
              )}
            </ABTest.Branch>
            <ABTest.Branch branch="T_B">{children}</ABTest.Branch>
          </>
        )}
      </ABTest.Context.Consumer>
    </ABTest>
  );
};

export default ABTestRedirectLoggedInToDocsList;
